import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type {
  BulkActionCustomDeleteCustomProperty,
  BulkActionResponseIncludesUpdatedFundProperties,
  BulkActionType,
} from 'donor-elf-web/models/bulk-action';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import Settings from 'donor-elf-web/services/settings';

interface ComponentArgs {
  propertyInfo: ContactCustomPropertyInfo;
  onClose: () => void;
}

export default class ContactDetailsPropertiesCustomPropertyDeleteModalComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;
  @service declare settings: Settings;
  @service declare store: Store;

  bulkActionType: BulkActionType = 'delete_custom_property';
  @tracked bulkActionCustom?: BulkActionCustomDeleteCustomProperty;

  @tracked deleting = false;
  @tracked deleteError = false;

  get contactsWithPropertyCount() {
    return this.contactsCache.contacts.filter(
      (x) => x.customPropertiesByLabel[this.args.propertyInfo.l] != null,
    ).length;
  }

  @action
  async delete() {
    this.bulkActionCustom = {
      property_label: this.args.propertyInfo.l,
    };
    this.deleting = true;
  }

  @action
  async onCompleted(response: BulkActionResponseIncludesUpdatedFundProperties) {
    await this.contactsCache.reloadSpecificContacts(response.contact_ids);
    await this.settings.contactCustomPropertyUserSetting?.reload();
    this.settings.fundSettings!.contactCustomInfo!.properties =
      response.updated_fund_properties;
    // break the custom properties cache
    this.contactsCache.customPropertiesCacheIndex += 1;
  }

  @action
  async onError() {
    this.deleteError = true;
  }
}
